export default __webpack_public_path__ + "static/interactive-map-570c1827820e3bd4ba2258f2915961d9.png";